import classNames from "classnames";
import React from "react";

export interface TableRowProps
  extends React.HTMLAttributes<HTMLTableRowElement> {
  interactive?: boolean;
}

export const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(
  ({ className, interactive = true, ...props }, ref) => (
    <tr
      ref={ref}
      className={classNames(
        "g-table__row",
        interactive && "g-table__row_interactive",
        className,
      )}
      {...props}
    />
  ),
);
TableRow.displayName = "TableRow";
